<div class="routes-calendar">
    <button (click)="setPreviousDate()" class="routes-calendar__change-day">
        <i class="pi pi-angle-left"></i>
    </button>

    <div (click)="onShowCalendar.emit()" class="routes-calendar__selected-day">
        <i class="pi pi-calendar"></i>

        <ng-container *ngIf="_selectedDateCalendar.length; else noSelectedDateInCalendar">
            <span 
                [ngClass]="{'without-dots': ifDateDayIsSame}"
                [title]="_selectedDateCalendar[0] | date: 'mediumDate' : '' : langauge"
                class="routes-calendar__selected-day__date from"
            >
                {{ _selectedDateCalendar[0] | date: 'mediumDate' : '' : langauge }}
            </span>
            <ng-container *ngIf="!ifDateDayIsSame">
                -
                <span [title]="_selectedDateCalendar[1] | date: 'mediumDate' : '' : langauge" class="routes-calendar__selected-day__date to">
                    {{ _selectedDateCalendar[1] | date: 'mediumDate' : '' : langauge  }}
                </span>
            </ng-container>
        </ng-container>

        <ng-template #noSelectedDateInCalendar>
            <span class="routes-calendar__selected-day__date from without-dots">
                {{ isMaxDate() ? ('date-time.today' | translate) : (initialDate[1] | date : 'mediumDate' : '' : langauge) }}
            </span>
        </ng-template>
    </div>

    <button 
        (click)="setNextDate()"
        [disabled]="isMaxDate()"
        class="routes-calendar__change-day"
    >
        <i class="pi pi-angle-right"></i>
    </button>
</div>